import DataQueryReducer from './DataQueryReducer';
import DetailReducer from './DetailReducer';
import ExampleReducer from './ExampleReducer';
import FindingsReducer from './FindingsReducer';
import GlobalReducer from './GlobalReducer';
import MessageReducer from './MessageReducer';
import PageReducer from './PageReducer';
import SettingsReducer from './SettingsReducer';
import UserReducer from './UsersReducer';

const reducers = {
  dataQuery: DataQueryReducer,
  detail: DetailReducer,
  example: ExampleReducer,
  findings: FindingsReducer,
  global: GlobalReducer,
  message: MessageReducer,
  page: PageReducer,
  settings: SettingsReducer,
  users: UserReducer,
};

export default reducers;



// WEBPACK FOOTER //
// ./src/redux/reducers.js